// extracted by mini-css-extract-plugin
export default {"root":"ContentHolder__root--tB1ZN","row":"ContentHolder__row--IQx98","full-width":"ContentHolder__full-width--AA8yV","fullWidth":"ContentHolder__full-width--AA8yV"};